@if(topBidders()?.length)
{
<div class="container">
    <div class="mt-8">
        <h1 class="text-[30px] font-bold font-mulish mb-2">Top Bidders</h1>
        <div class="bg-white shadow-md rounded-lg ">
            @for (bidder of this.topBidders()| slice:0:5; track bidder.username) {
            <div class="">
                <div class="px-[10px] pt-[19px] h-[108px] flex overflow-visible">
                    <div class="text-[20px] font-semibold !text-[var(--p-text-color-secondary)] tracking-[0.08px] leading-[24px] font-mulish 
                    w-[56px] h-[56px] bg-[var(--p-info-500)] rounded-full 
                    shrink-0  flex items-center justify-center">{{this.printFirstLetters(bidder.username!)}}</div>
                    <div class="ml-5 flex flex-col w-full overflow-hidden">
                        <h3 class="text-[20px] leading-[24px] text-[var(--p-info-500)] font-bold font-mulish truncate">
                            {{bidder.username}}</h3>
                        <h3 class="text-[18px] leading-[22px] mt-[12px] text-black font-semibold font-mulish ">
                            {{bidder.amount | currency}}</h3>
                    </div>
                </div>
                <div class="px-3">
                    <div class="bg-[#CED4DA] h-0.5 w-full"></div>
                </div>
            </div>
            }
        </div>
    </div>
</div>

}